module.exports = __webpack_public_path__ + "img/logo_head.d70cb928.png";